import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
export function usePending(handler) {
  var pending = ref(false);
  onBeforeMount(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return refresh();
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  var refresh = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var togglePending,
        _args2 = arguments;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            togglePending = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : true;
            _context2.prev = 1;
            pending.value = togglePending;
            _context2.next = 5;
            return handler();
          case 5:
            _context2.prev = 5;
            pending.value = false;
            return _context2.finish(5);
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1,, 5, 8]]);
    }));
    return function refresh() {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    pending: pending,
    refresh: refresh
  };
}